import bleach from 'bleach';

export const sanitizeContent = (content, options = {}) => {
	const newOptions = {
		...options,
		mode: 'black',
		list: ['script']
	};

	return bleach.sanitize(content, newOptions);
};

export const sortSpecCategories = specCategories => {
	// Talking with TL;DR about getting a unique ID added to categories in VCDA
	// so that we can prioritize with consistent values across all locales,
	// but for now we have to match on category name
	const sortedSpecCategories = specCategories.map(specCat => {
		let priority;
		switch (specCat.category) {
			case 'Convenience Features':
			case 'Commodités':
				priority = 1;
				break;
			case 'Suspension/Handling':
			case 'Suspension/tenue de route':
				priority = 2;
				break;
			case 'Entertainment Features':
			case 'Chaînes récréatives':
				priority = 3;
				break;
			case 'Warranty':
			case 'Garanties':
				priority = 4;
				break;
			case 'Seats and Trim':
			case 'Sièges et garniture':
				priority = 5;
				break;
			case 'Powertrain':
			case 'Groupes motopropulseurs':
				priority = 6;
				break;
			case 'Off-Road Capability':
			case 'Hors-route':
				priority = 7;
				break;
			case 'Body Exterior':
			case 'Extérieur':
				priority = 8;
				break;
			case 'Specs and Dimensions':
			case 'Spécifications et dimensions':
				priority = 9;
				break;
			case 'Lighting, Visibility and Instrumentation':
			case 'Éclairage, visibilité et instruments':
				priority = 10;
				break;
			case 'Safety and Security':
			case 'Sûreté et sécurité':
				priority = 11;
				break;
			default:
				priority = 12;
				break;
		}
		return {
			category: specCat.category,
			specIds: specCat.specIds,
			priority
		};
	});

	sortedSpecCategories.sort((a, b) => a.priority - b.priority);

	return sortedSpecCategories;
};

/*
	Remove any category from categories that is included in the excludedCategories
	pipe separated value string.
	We prepend and append a pipe to the entire preference value in order to facilitate exact string matches.
	ex. |feature|awesome feature|windows| contains |feature| exactly and won't match |awesome feature|
*/
export const filterExcludedCategories = (categories, excludedCategories) =>
	categories.filter(
		spec =>
			`|${excludedCategories.trim().toLowerCase()}|`.indexOf(
				`|${spec.category.trim().toLowerCase()}|`
			) === -1
	);



// WEBPACK FOOTER //
// ./src/utils/helper.js